var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isDarkModeEnabled ? 'theme--dark' : 'theme--light'},[_c('div',{attrs:{"id":"app"}},[_c('head',[_c('title',[_vm._v(" "+_vm._s("process.env.VUE_APP_NAME" + " | Comenta y postea anonimamente")+" ")])]),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }